/**
 * Búsqueda global del top bar (⌘K): filtra sprints, HTs y services visibles.
 */

import { api } from "./client";

export interface SearchSprint {
  id: string;
  name: string;
  code: string | null;
}

export interface SearchHt {
  id: number;
  ht_code: string;
  project_id: string;
  project_name: string;
}

export interface SearchService {
  id: string;
  name: string;
  code: string | null;
}

export interface SearchResults {
  q: string;
  sprints: SearchSprint[];
  hts: SearchHt[];
  services: SearchService[];
}

/** `workspaceId` acota los sprints al workspace seleccionado en el sidebar. */
export async function globalSearch(
  q: string,
  workspaceId?: string | null,
): Promise<SearchResults> {
  const params: Record<string, string> = { q };
  if (workspaceId) params.workspace_id = workspaceId;
  const res = await api.post<SearchResults>("/search/get", { ...params });
  return res.data;
}
